import { useState, useCallback } from "react";
import { FileService } from "../services/staffandplant/plantService";

export const useFileUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const uploadFiles = useCallback(async (files, isOrg = true) => {
    if (!files || files.length === 0) {
      throw new Error("No files provided");
    }

    setUploading(true);
    setUploadError(null);

    try {
      const results = await FileService.uploadMultipleFiles(files, isOrg);

      if (results.failed.length > 0) {
        console.warn("Some files failed to upload:", results.failed);
        setUploadError(`Failed to upload ${results.failed.length} files`);
      }

      return results;
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError(error.message || "Failed to upload files");
      throw error;
    } finally {
      setUploading(false);
    }
  }, []);

  const uploadSingleFile = useCallback(async (file, isOrg = true) => {
    if (!file) {
      throw new Error("No file provided");
    }

    setUploading(true);
    setUploadError(null);

    try {
      const result = await FileService.uploadFile(file, isOrg);
      return result;
    } catch (error) {
      console.error("Single file upload error:", error);
      setUploadError(error.message || "Failed to upload file");
      throw error;
    } finally {
      setUploading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setUploadError(null);
  }, []);

  return {
    uploadFiles,
    uploadSingleFile,
    uploading,
    uploadError,
    clearError,
  };
};
